module.exports = __webpack_public_path__ + "img/mobileid.6f258a5b.png";